export default __webpack_public_path__ + "static/media/photoJenya.762c0592.jpg";